import BaseComponent, { defineComponent } from '@/components/base';
import RechargeGateway from '@/gateway/Recharge';
import RecommendationCard from '@/components/account/recommendation-card';
import { FontStyle } from '@/components/style';
import RecommendationsUtils from '@/components/account/recommendations/utils';

export default class Recommendations extends BaseComponent {
  static get observedAttributes() {
    return ['customer-id', 'recommendations'];
  }
  onConstruct() {
    defineComponent('recommendation-card', RecommendationCard);
    RechargeGateway.getCustomerId().then((id) => {
      this.customerId = id;
      RecommendationsUtils.getRecommendations(this.customerId)
        .then((data) => {
          this.recommendations = data;
        })
        .catch((error) => {
          console.error(error);
          this.recommendations = [];
        });
    });
  }

  afterMount() {}

  render() {
    const showComponent =
      this.recommendations && this.recommendations.length > 0;
    if (!showComponent) {
      return '';
    }
    const settings = JSON.parse(window.localStorage.getItem('fob-settings'));
    return `
    ${FontStyle}
    <style>
      .account-promo-carousel-wrapper {
        width: 100%;
        padding:${this.isSmall ? '32px 0' : '54px 48px 0 25px'} ;
      }
       .my-offers-title-wrapper {
          padding: ${this.isSmall ? '0' : '0 48px'}
        }
        .my-offers-title {
          color: #717575;
          margin-bottom: 12px;
        }
        .recommendations-wrapper {
          padding: ${this.isSmall ? '0' : '0 48px'};
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
        }
    </style>

    <div class="account-promo-carousel-wrapper">
      <div class="my-offers-title-wrapper">
          <h4 class="my-offers-title body-font-1">
            ${settings.recommendation_header}
          </h4>
      </div>
      <div class="recommendations-wrapper">
        ${
          Array.isArray(this.recommendations)
            ? this.recommendations
                .map(
                  (recommendation) =>
                    `<recommendation-card
                        title="${recommendation.title}"
                        description="${recommendation.description}"
                        image="${recommendation.products[0].image}"
                        link="/products/${recommendation.products[0].handle}?source=recommendation"
                    ></recommendation-card>
                    `
                )
                .join('')
            : ''
        }
      </div>
    </div>
  `;
  }

  get customerId() {
    return this.getAttribute('customer-id');
  }

  set customerId(value) {
    this.setAttribute('customer-id', value);
  }

  get recommendations() {
    const recommendationsArray = JSON.parse(
      this.getAttribute('recommendations') || '[]'
    );
    return recommendationsArray.length > 0 ? [recommendationsArray[0]] : [];
  }

  set recommendations(value) {
    this.setAttribute('recommendations', JSON.stringify(value));
  }
}
